import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import LegalFooterLinks from '@/components/LegalFooterLinks';

const Footer = () => {
  return (
    <footer className="w-full py-4 px-6 border-t border-gray-200 bg-white/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-sm text-muted-foreground">
          © 2026 All rights reserved.
        </p>
        <LegalFooterLinks />
        <Link 
          to="/contact-us" 
          className="text-sm text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1 font-medium"
          data-testid="contact-us-link"
        >
          <Mail className="w-4 h-4" />
          Contact Us
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
